<div class="m-0 bg">
  <!--Navbar-->
  <nav class="navbar navbar-expand-lg navbar-dark b2-navigation">
    <a class="navbar-brand" href="#">
      <img src="/images/bauplus.png" class="mx-2" alt="BauPlus" />
      BauPlus Mobile
    </a>
  </nav>

  <div class="d-flex justify-content-center top-margin-content">
    <div class="col-md-8 col-lg-6 col-xl-4">
      <div id="alert_placeholder"></div>
      <div class="text-center card">
        <div class="card-body m-1 m-md-3 m-lg-4">
          <h5 class="card-title">Passwort geändert</h5>
          <div>Das Passwort wurde erfolgreich geändert.</div>
          <div>Bitte mit dem neuen Passwort an BauPlus Mobile anmelden.</div>
          <div>
            <button type="button" class="btn b2-color-delete-reversed mt-4" (click)="toLogin()">
              <i class="fal fa-sign-in me-2" aria-hidden="true"></i>
              Zur Anmeldung
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
